import { useTheme } from '../../app/ThemeContext'
import AccountMenu from './AccountMenu'

interface WorkspaceTopbarProps {
  userName: string
  roleLabel: string
  onToggleSidebar: () => void
  onOpenCustomizer: () => void
}

export default function WorkspaceTopbar({ roleLabel, onToggleSidebar, onOpenCustomizer }: WorkspaceTopbarProps) {
  const { resolvedTheme, setMode } = useTheme()

  return (
    <header className="admin-navbar">
      <button className="navbar-icon" type="button" onClick={onToggleSidebar} aria-label="Toggle sidebar"><i className="bi bi-list" /></button>
      <div className="topbar-context">
        <strong>{roleLabel}</strong>
        <span>Secure healthcare workspace</span>
      </div>
      <div className="navbar-actions">
        <button className="navbar-icon" type="button" onClick={() => setMode(resolvedTheme === 'dark' ? 'light' : 'dark')} aria-label={`Switch to ${resolvedTheme === 'dark' ? 'light' : 'dark'} theme`}>
          <i className={`bi ${resolvedTheme === 'dark' ? 'bi-sun' : 'bi-moon-stars'}`} />
        </button>
        <button className="navbar-icon hide-narrow" type="button" onClick={onOpenCustomizer} aria-label="Open theme settings"><i className="bi bi-sliders" /></button>
        <AccountMenu label={roleLabel} />
      </div>
    </header>
  )
}
